import { validateExcludeRegex } from 'hb-react/shared/utils/validators/excludeRegex';
import { validateMaxEmailsInline } from 'hb-react/shared/utils/validators/maxEmailsInline';
import { validateMaxLength } from 'hb-react/shared/utils/validators/maxLength';
import { validateRequired } from 'hb-react/shared/utils/validators/required';
import { validateEmailsInline } from 'hb-react/shared/utils/validators/validEmailsInline';

export const validateTextarea = ({
  excludeRegex,
  maxEmailsInline,
  maxLength,
  required,
  validEmailsInline,
  value,
}) => {
  let error;

  if (required) {
    error = validateRequired(value);
  }

  if (maxLength && !error) {
    error = validateMaxLength(value, maxLength);
  }

  if (validEmailsInline && !error) {
    error = validateEmailsInline(value);
  }

  if (maxEmailsInline && !error) {
    error = validateMaxEmailsInline(value, maxEmailsInline);
  }

  if (excludeRegex && !error) {
    error = validateExcludeRegex(value, excludeRegex);
  }

  return error;
};
